'use client'

import { useState, useCallback } from 'react'
import { type DateRange } from 'react-day-picker'
import { subDays } from 'date-fns'

import { DateRangePicker } from "./DateRangePicker"

interface CustomDatePickerProps {
  value?: DateRange
  onChange?: (range: DateRange | undefined) => void
  className?: string
  onApply?: (range: DateRange | undefined) => void
}

const CustomDatePicker = ({
  value: externalValue,
  onChange: externalOnChange,
  className,
  onApply,
}: CustomDatePickerProps) => {
  // Internal state for uncontrolled mode - default to last 30 days
  const [internalValue, setInternalValue] = useState<DateRange | undefined>({
    from: subDays(new Date(), 29),
    to: new Date(),
  })
  const [customPickerOpen, setCustomPickerOpen] = useState(false)

  // Use external value if provided, otherwise use internal state
  const value = externalValue !== undefined ? externalValue : internalValue
  const onChange = externalOnChange || setInternalValue

  const handleCustomRangeChange = useCallback((range: DateRange | undefined) => {
    onChange(range)
  }, [onChange])

  return (
    <DateRangePicker
      value={value}
      onChange={handleCustomRangeChange}
      open={customPickerOpen}
      onOpenChange={setCustomPickerOpen}
      className={className}
      onApply={onApply}
    />
  )
}

export { CustomDatePicker }
export type { CustomDatePickerProps }
